import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layout
import Layout from "./components/layout/Layout";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import NutritionalTherapyPage from "./pages/NutritionalTherapyPage";
import DetoxSupportPage from "./pages/DetoxSupportPage";
import ServicesPage from "./pages/ServicesPage";
import OrientationPage from "./pages/OrientationPage";
import ClassesPage from "./pages/ClassesPage";
import ContactPage from "./pages/ContactPage";
import PureRenewalPage from "./pages/PureRenewalPage";

// Scroll to top on route change
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/nutritional-therapy" element={<NutritionalTherapyPage />} />
          <Route path="/detox-support" element={<DetoxSupportPage />} />
          <Route path="/pure-renewal-protocol" element={<PureRenewalPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/orientation" element={<OrientationPage />} />
          <Route path="/classes" element={<ClassesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
